module.exports = require('./dist/storage/storage.js');
